import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import Box from "@mui/material/Box";
import { TextInput } from "./Input";
import { MaskInput } from "./MaskInput";
import { SelectInput } from "./SelectInput";
import { PrimaryButton } from "./PrimaryButton";
import { useState } from "react";
import { AppContext } from "../context";
import { useContext } from "react";
import { format, parse } from "date-fns";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { getProfessions } from "../services/api";
import RadioButton from "./RadioButton";
import AlertField from "./Alert";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import WcOutlinedIcon from '@mui/icons-material/WcOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';

export const Form = () => {
  const { createLead, plan } = useContext<any>(AppContext);
  const [professionValue, setProfessionValue] = useState('')
  const [professionOption,setProfessionOption]= useState<any>([])
  const [openAlert, setOpenAlert] = useState<boolean>(false)
  const [alertMessage, setAlertMessage] = useState<string>('')
  const [ salary, setSalary] = useState("")
  const [ statusCivil, setStatusCivil] = useState("")
  const [ sex, setSex] = useState("")


  useEffect(() => {
    createProfessionList()
  }, [])

  const handleClose = () => {
    setOpenAlert(false)
  }

  const createProfessionList = async () => {
    const professions = await getProfessions()
    setProfessionOption(professions)
  }

  const handleProfession = (value: any) => {
    setProfessionValue(value);
  };

  const statusOptions  = [
    {value: 'Solteiro', label: 'Solteiro'},
    {value: 'Casado', label: 'Casado'},
    {value: 'Separado', label: 'Separado'},
    {value: 'Divorciado', label: 'Divorciado'},
    {value: 'Viúvo', label: 'Viúvo'}
  ]

  const salaryOptions  = [
    {value: '1500', label: 'Até R$ 1.500'},
    {value: '3000', label: 'Entre R$ 1.500 e R$ 3.000'},
    {value: '5000', label: 'Superior a R$ 3.000'}
  ]

  const exposedOptions = [
    {value: 'true', label: 'Sim'},
    {value: 'false', label: 'Não'},
  ]

  const genderOptions = [
    {value: 'M', label: 'Masculino'},
    {value: 'F', label: 'Feminino'}
  ]

  const handleSalary = (value: string) => {
    setSalary(value)
  }

  const handleStatus = (value: string) => {
    setStatusCivil(value)
  }

  const handleGender = (value: string) => {
    setSex(value)
  }

  const history = useHistory();
  const handleSubmit = (e: any) => {
    e.preventDefault();
    
    const data = {
      name: e.target?.name.value,
      cpf: e.target?.cpf.value.replace(/\D/g, ""),
      status_civil: statusCivil,
      birthday: e.target?.birthday.value,
      sex: sex,
      profession: professionValue,
      salary: salary,
      exposed: e.target?.exposed.value
    };
    
    if (!data.name) {
      setAlertMessage('Nome não informado!')
      setOpenAlert(true)
    } else if(!data.cpf) {
      setAlertMessage('CPF não informado!')
      setOpenAlert(true)
    } else if(!data.status_civil) {
      setAlertMessage('Estado civil não informado!')
      setOpenAlert(true)
    } else if(!data.birthday) {
      setAlertMessage('Data de nascimento não informada!')
      setOpenAlert(true)
    } else if(!data.sex) {
      setAlertMessage('Sexo não selecionado!')
      setOpenAlert(true)
    } else if(!data.profession) {
      setAlertMessage('Profissão não selecionada!')
      setOpenAlert(true)
    } else if(!data.salary) {
      setAlertMessage('Média Salarial não selecionada!')
      setOpenAlert(true)
    }else if(!data.exposed) {
      setAlertMessage('Politicamente Exposto não selecionada!')
      setOpenAlert(true)
    }
    else {
      const formatedDate = format(
      parse(e.target?.birthday.value, "dd/MM/yyyy", new Date()),
      "yyyy-MM-dd"
      );
      const metaData = {
        name: e.target?.name.value,
        cpf: e.target?.cpf.value.replace(/\D/g, ""),
        status_civil: statusCivil,
        birthday: formatedDate,
        sex: sex,
        profession: professionValue,
        salary: salary,
        exposed: e.target?.exposed.value,
        selected_product: plan.plan_selected,
        mql: true
      }
      const res = createLead(metaData);
      console.log(res)
      if (res) {
        history.push("/endereco");
    }
    }
    
  };

  return (
    <Box
      style={{ width: "100vw" }}
      sx={{
        marginTop: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <form onSubmit={handleSubmit}>
        
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <AlertField message={alertMessage} status={openAlert} handle={handleClose} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <AccountCircleOutlinedIcon sx={{ color: "#656565", mr: 1, my: 1.5 }} />
            <TextInput 
              id='name'
              label='Nome'
            />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <ArticleOutlinedIcon sx={{ color: "#656565", mr: 1, my: 1.5 }} />
          <MaskInput
            mask="999.999.999-99"
            id="cpf"
            label="CPF"
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <CalendarTodayOutlinedIcon
            sx={{ color: "#656565", mr: 1, my: 1.5 }}
          />
          <MaskInput mask="99/99/9999" id="birthday" label="Nascimento" />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
           <AttachMoneyOutlinedIcon
             sx={{ color: "#656565", mr: 1, mb:1.5}}
           />
           <SelectInput
             label="Média Salarial"
             id="salary"
             options={salaryOptions}
             handleClick={handleSalary}
           />
           </Box>
        {professionOption && (
           <Box sx={{ display: "flex", alignItems: "flex-end" }}>
           <WorkOutlineOutlinedIcon
             sx={{ color: "#656565", mr: 1, mb:1.5}}
           />
           <SelectInput
             label="Profissão"
             id="profession"
             options={professionOption}
             handleClick={handleProfession}
           />
           </Box>
        )}
        <Box sx={{ display: "flex", alignItems: "flex-end"}}>
          <FavoriteBorderOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1.5}} />
          <SelectInput 
          label='Estado Civil' 
          id='status_civil' 
          options={statusOptions}
          handleClick={handleStatus}/>
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end"}}>
          <WcOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1.5}} />
          <SelectInput 
          label='Sexo' 
          id='sex' 
          options={genderOptions}
          handleClick={handleGender}/>
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end", ml: 4, mt: 1}}>
          <RadioButton label='Exposto Politicamente' id='exposed' options={exposedOptions}/>
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <PrimaryButton name="Prosseguir" />
        </Box>
      </form>
    </Box>
  );
};
